import IndividualGymRatings from "../pages/Gyms/components/IndividualGymRatings";
import ChangePassword from "../pages/Settings/ProfileSetting/ChangePassword";

export default {
  // auth
  googleAuthentication: "/auth/google",
  login: "/auth/login",
  logout: "/auth/logout",
  verify: "/auth/verify/otp",
  resendOtp: "/auth/resend-otp",
  reset: "/auth/reset",
  updatePassword: "/auth/reset-code",
  gym: "/gym",
  gymCategory: "/gym/categories",
  pass: "/pass",
  adminPass: "/pass/adminPass",
  user: "user",
  changePassword: "/user/setpassword",
  register: "register",
  equip: "/equip",
  gymEquipment: "/equip/gym",
  roles: "/role",
  graph: "/gym/graph",
  staff: "/staff",
  owner: "/user/owner",
  staffImage: "/staff/images",
  blog: "/blog",
  delMedia: "/gym/del",
  logout: "/auth/logout",
  help: "/help",
  request: "/feature/",
  contact: "/contact/",
  reply: "feature/reply",
  fcm: "/user/fcm",
  amenity: "/gym/amenities/",
  notification: "/notification",
  revenue: "/pass/authorize/list",
  incomestats: "/wallet/gym",
  redeem: "/pass/redeem",
  getRedeemPass: "/pass/authorize/list",
  redeemDetail: "/pass/redeem/detail",
  transaction: "/trans",
  business: "/gym/business",
  wallet: "/wallet/gym",
  wallets: "/wallet/gyms",
  bank: "/gym/bank",
  gymPayout: "/payment/debit/account",
  finance: "/gym/money",
  publicRedeem: "/pass/public/redeem",
  publicRedeemDetail: "/pass/public/redeem/detail",
  gymSingleRatings: "/gym/rating/gym/",
  gymAllRatings: "/gym/rating/all",
  gymRatings: "/gym/rating/gym",
  IndividualGymRatings: "/gym/rating/?gymId=",
  seeder: "/seeder/gym/",
  brand:'/brand',
  
};
